import { AppThunk } from '../../../../../store/types';
import { getMainViewMode } from '../../../../../store/general/selectors';
import { PhraseDetailsEffects } from '../../../../../effects/phrase-details/phrase-details-effects';
import { EMainViewMode } from '../../../../../store/general/types';

export class PhraseDetailsContainerEvents {

  public static onLoad(): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const mainViewMode = getMainViewMode(getState());
      if (mainViewMode === EMainViewMode.PHRASE_DETAILS) return; // mobile
    }
  }

}